import { DOCUMENT_TERMS_AND_CONDITIONS } from "core/consts";
import CheckboxInputField from "ds_legacy/components/CheckboxInputField";
import InfoCaption from "ds_legacy/components/InfoCaption";
import LinkV2, { useExternalLinkLabel } from "ds_legacy/components/LinkV2";
import { margin } from "ds_legacy/materials/metrics";
import { Caption, FONT_SIZE_14 } from "ds_legacy/materials/typography";
import { useTranslations } from "translations";
import { TranslationComposition } from "translations/helpers";
import { useLegalDocuments } from "./LegalDocuments";

export const TermsAndConditions = () => {
  const { getDocument } = useLegalDocuments();
  const termsAndConditions = getDocument(DOCUMENT_TERMS_AND_CONDITIONS);
  const translations = useTranslations();
  const externalLinkLabel = useExternalLinkLabel();

  if (!termsAndConditions?.needs_to_sign) return null;

  return (
    <>
      <div className="m-4 flex flex-1 flex-col">
        <CheckboxInputField
          elementName="terms_and_conditions"
          label={
            <Caption
              fontSize={FONT_SIZE_14}
              margin={margin(0)}
              whiteSpace="normal"
            >
              <TranslationComposition
                translations={translations.termsAndConditions.accept}
                withOptions
              >
                {([before, link, after]) => (
                  <>
                    {before}
                    <LinkV2
                      aria-label={externalLinkLabel(
                        termsAndConditions.url,
                        "website",
                      )}
                      href={termsAndConditions.url}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {link}
                    </LinkV2>
                    {after}
                  </>
                )}
              </TranslationComposition>
            </Caption>
          }
          required
        />
      </div>
      {termsAndConditions.needs_to_sign && (
        <InfoCaption
          margin={margin(0, 3)}
          text={translations.legal.differencesInTCVersions}
        />
      )}
    </>
  );
};
